import { Box, Flex, Text, Button, Input, IconButton, useToast } from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";
import { isWebUser } from "@utils/helpers";
import { useProfile } from "@hooks";

// NOTE: DEPRECATED
const AgendaMeetingItem = ({ title, onEdit, isDisabled, agenda }) => {
  const { profile } = useProfile();
  const toast = useToast();
  const showJoinCode = isWebUser(profile);
  
  const handleCopyJoinUrl = () => {
    if (agenda?.joinCode) {
      const joinUrl = `${window.location.origin}/join/${agenda.joinCode}`;
      navigator.clipboard.writeText(joinUrl);
      toast({
        title: "Join URL copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    }
  };
  return (
    <Box border="1px solid #F5F5F7" p="10px" borderRadius="8px" mb="8px">
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize="12px" isTruncated={true} maxW="180px">
          {title}
        </Text>
        <Flex>
          <Button
            variant="secondary"
            size="xs"
            onClick={onEdit}
            disabled={isDisabled}
          >
            Edit
          </Button>
        </Flex>
      </Flex>
      
      {/* Join Code Section for Web Users */}
      {showJoinCode && agenda?.joinCode && (
        <Box mt="8px" pt="8px" borderTop="1px solid #F5F5F7">
          <Text fontSize="10px" color="gray.600" mb="4px">
            Share this link with participants:
          </Text>
          <Flex alignItems="center" gap="4px">
            <Input
              value={`${window.location.origin}/join/${agenda.joinCode}`}
              isReadOnly
              size="sm"
              fontSize="10px"
              bg="gray.50"
              border="1px solid #E2E8F0"
              data-testid="agenda-join-url-input"
            />
            <IconButton
              size="sm"
              icon={<CopyIcon />}
              onClick={handleCopyJoinUrl}
              aria-label="Copy join URL"
              variant="outline"
            />
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default AgendaMeetingItem;
